import { render, staticRenderFns } from "./TenantPage.vue?vue&type=template&id=daf1ecb8&scoped=true&"
import script from "./TenantPage.vue?vue&type=script&lang=js&"
export * from "./TenantPage.vue?vue&type=script&lang=js&"
import style0 from "./TenantPage.vue?vue&type=style&index=0&id=daf1ecb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf1ecb8",
  null
  
)

export default component.exports